import config from '@/config'

export default {
  user_status: {
    NEW: "新用户,但尚未验证",
    ACTIVE: "活跃用户",
    RESET: "用户密码已重置",
    ATTEMPT_BLOCK: "用户因3次登录失败被锁定",
    COMPANY_BLOCK: "用户被公司锁定",
    SUSPEND: "用户已暂停"
  },

  login: "登录到您的帐户",
  relogin: "请重新登录到您的帐户。",
  expired: "会话已过期!",
  denied: "权限被拒绝!",
  success: "您已成功完成!",
  search_by_id: "按ID搜索",
  search_by_full_id: "按完整ID搜索",
  successful_change_password: "您已成功更改密码。",
  select_option: "选择您的选项",
  no_data_available: "没有可用数据",
  no_rating_available: "没有可用评级",
  successful_update_security: "您已成功更新安全性。",
  successful_disable_security: "您已成功禁用安全性。",
  update_security_confirm: "您确定要更新安全性吗？",
  disable_security_confirm: "您确定要禁用安全性吗？",
  change_operator_status_confirm: "您确定要更改运营商\"\"{name}\"状态吗？",
  change_member_status_confirm: "您确定要更改会员\"\"{name}\"状态吗？",
  change_bank_account_status_confirm: "您确定要更改\"{name}\"帐户状态吗？",
  change_promotion_seq_confirm: "您确定要更改\"{id}\"的顺序吗？",
  change_promo_status_confirm: "您确定要更改\"{name}\"促销状态吗？",
  change_promo_signup_status_confirm: "您确定要更改\"{name}\"促销注册状态吗？",
  successful_update_account_setup: "您已成功更新帐户设置。",
  unblock_member_confirm: "您确定要解锁会员\"{name}\"吗？",
  unblock_operator_confirm: "您确定要解锁运营商\"{name}\"吗？",
  block_sub_account_confirm: "您确定要封锁子帐户\"{name}\"吗？",
  unblock_sub_account_confirm: "您确定要解锁子帐户\"{name}\"吗？",
  successful_create_secondary_account: "您已成功创建辅助帐户。",
  successful_update_account_password: "您已成功更新帐户密码。",
  update_account_password_cancel: "您确定要取消更新帐户密码吗？",
  change_affiliate_status_confirm: "您确定要更改代理\"{name}\"状态吗？",
  unblock_affiliate_confirm: "您确定要解锁代理\"{name}\"吗？",
  change_coupon_status_confirm: "您确定要更改\"{name}\"优惠券状态吗？",
  submit_acknowledgement_confirm: "您确定要提交确认吗？",
  change_bank_group_default_confirm: "您确定要将\"{name}\"设置为默认银行组吗？",
  change_withdrawal_limit_default_confirm: "您确定要将\"{name}\"设置为默认提款限额吗？",
  change_promotion_group_default_confirm: "您确定要将\"{name}\"设置为默认促销组吗？",
  change_referral_status_confirm: "您确定要更改\"{name}\"推荐状态吗？",
  change_withdrawal_limit_confirm: "您确定要更改\"{name}\"提款限额吗？",
  change_promotion_group_confirm: "您确定要更改\"{name}\"促销组吗？",
  change_bank_group_confirm: "您确定要更改\"{name}\"银行组吗？",
  change_member_bet_limit_confirm: "您确定要更改\"{name}\" \"{provider}\"投注限额吗？",
  assign_free_credit_confirm: "您确定要为\"{name}\"分配免费信用吗？",
  update_survey_status_confirm: "您确定要更新调查状态吗？",
  move_banner_up_confirm: "您确定要将横幅\"{name}\"上移吗？",
  move_banner_down_confirm: "您确定要将横幅\"{name}\"下移吗？",
  delete_banner_confirm: "您确定要删除横幅\"{name}\"吗？",
  change_banner_status_confirm: "您确定要更改横幅\"{name}\"状态吗？",
  delete_page_confirm: "您确定要删除页面\"{name}\"吗？",
  change_page_status_confirm: "您确定要更改页面\"{name}\"状态吗？",
  clear_maintenance_time_confirm: "您确定要清除\"{name}\"维护时间吗？",
  successful_clear_outstanding: "您已成功清除{amt}的未结余额。",
  clear_outstanding_confirm: "您确定要清除\"{name}\"未结余额吗？",
  trace_outstanding_confirm: "您确定要跟踪\"{name}\"未结余额吗？",
  change_setting_confirm: "您确定要更改\"{name}\"设置吗？",
  add_bonus_list_member_confirm: "您确定要将所选会员添加到奖金列表吗？",
  delete_bonus_list_member_confirm: "您确定要从奖金列表中删除所选会员吗？",
  delete_ip_address_confirm: "您确定要删除\"{name}\"下的IP地址\"{ip}\"吗？",
  add_ip_address_confirm: "您确定要在\"{name}\"下添加IP地址\"{ip}\"吗？",
  change_payment_mode_status_confirm: "您确定要更改\"{name}\"支付方式状态吗？",
  change_provider_group_status_confirm: "您确定要更改\"{mode}\"下的\"{group}\"状态吗？",
  bulk_issue_bonus_member_confirm: "您确定要向奖金列表中的会员发放奖金吗？",
  change_provider_group_recommend_confirm: "您确定要更改\"{mode}\"下的\"{group}\"推荐吗？",
  change_provider_group_seq_confirm: "您确定要更改\"{mode}\"下的\"{group}\"顺序吗？",
  no_member_found: "没有找到会员",
  redeposit_ticket_confirm: "您确定要重新存款工单吗？",
  change_provider_group_limit_confirm: "您确定要更改\"{mode}\"下的\"{group}\"限额吗？",
  audit_ticket_confirm: "您确定要审核该工单吗？",
  review_ticket_confirm: "您确定要审查该工单吗？",
  change_promotion_group_seq_confirm: "您确定要更改\"{promotion}\"下的\"{group}\"顺序吗？",
  unlock_custom_vip_confirm: "您确定要解锁\"{name}\"定制vip吗?",
  move_affiliate_confirm: "您确定要将\"{name}\"整个分支代理迁移到\"{operator}\"吗?",
  cancel_unfinish_round_confirm: "您确定要取消未完成的回合 \"{round}\" 吗？",
  change_payment_mode_seq_confirm: "您确定要更改\"{mode}\"的顺序吗？",
  remove_bank_default_provider_confirm: "您确定要移除\"{bank}\"默认提供商?",
  change_label_status_confirm: "您确定要更改\"{name}\"标签状态吗？",
  clear_iframe_url_confirm: "您确定要清除内嵌框架网址吗？",
  delete_turnover_tier_confirm: "您确定要删除 \"{name}\" 流水层级吗？",
  vip_provider_rebate_batch_confirm: "您是否确认继续进行VIP提供商返利批量更新?",
  copy_rebate_rate_all_confirm: "您确定要将 \"{provider}\" 的 \"{name}\" 复制到所有供应商吗？",
  edit_vip_confirm: "您确定要更新 \"{name}\" 的返利率吗？",
  add_promotion_custom_member_confirm: "您确定要添加促销自定义会员列表吗？",
  delete_promotion_custom_member_confirm: "您确定要删除 \"{name}\" 的促销自定义会员列表吗？",
  change_rescue_fund_status_confirm: "您确定要更改 \"{name}\" 的救助基金状态吗？",
  add_rescue_fund_custom_member_confirm: "您确定要添加救助基金自定义会员列表吗？",
  delete_rescue_fund_custom_member_confirm: "您确定要删除 \"{name}\" 的救助基金自定义会员列表吗？",
  change_ads_status_confirm: "您确定要更改 \"{name}\" 广告状态吗？",
  adjust_amount_bank_tooltip: "支持减号 (-) 从银行账户余额中扣除金额",
  adjust_amount_operator_tooltip: "支持减号 (-) 从操作员钱包中扣除金额",
  adjust_amount_member_tooltip: "支持减号 (-) 从会员余额中扣除金额",
  purchase_domain_tooltips: "恭喜你！！预祝你赚到人生的一个小目标！",
  change_provider_game_seq_confirm: "您确定要更改\"{mode}\"的顺序吗？",
  purchase_domain_confirm: "您确定要购买 \"{name}\" 域名吗？",
  search_by_domain_name: "按域名搜索",
  search_by_domain_status: "按域名状态搜索",
  search_by_account_id: "按账户ID搜索",
  search_by_operator_id: "按操作员ID搜索",
  search_by_full_name: "按全名搜索",
  search_by_contact_phone: "按联系电话搜索",
  search_by_signup_ip: "按注册IP搜索",
  search_by_referral_code: "按推荐码搜索",
  search_by_bank_acc_no: "按银行账号搜索",
  search_by_affiliate_code: "按代理代码搜索",
  info1: "1. 不允许使用子域名",
  info2: "2. 不需要输入 'https://' 或 'http://'",
  info3: "3. 示例: abc.com",
  move_announcement_banner: "重新排序横幅",
  atLeastOneChecked: "至少需要勾选一个阈值",
  adjustWalletTooltips: "支持减号 (-) 从代理钱包中扣除余额",
  emailOTPTooltips: "邮箱验证码将在请求后 3 分钟内过期",
  domain_status_update_confirm: "您想更新 \"{name}\" 的状态吗？",
  delete_access_control_confirm: "您确定要移除 \"{name}\" 吗？",
  delete_access_control_success: "您已成功移除 \"{name}\"。",
  add_access_control_confirm: "您确定要添加访问控制吗？",
  add_access_control_success: "您已成功添加访问控制。",
  delete_access_auto_confirm: "您确定要移除 \"{name}\" 吗？",
  delete_access_auto_success: "您已成功移除 \"{name}\"。",
  add_access_auto_confirm: "您确定要添加到自动分配吗？",
  add_access_auto_success: "您已成功添加到自动分配。",
  move_banner_confirm: "您确定要将 \"{name}\" 更改为位置 \"{position}\" 吗？",
  delete_game_exclude_confirm: "您确定要删除 \"{name}\" 吗？",
  banner_size_tooltips: "请遵循允许的图像尺寸: \"{size}\"。",
  purchase_domain_success: "购买域名成功！",
  purchase_domain_failed: "购买域名失败！",
  apply_domain_success: "应用域名成功！",
  apply_domain_failed: "应用域名失败！",
  tooltips_pnl: "平台盈亏 x 平台 PT % = 总收益",
  delete_package_confirm: "您确定要删除 \"{package}\" 套餐吗",
  search_by_lang_code: "按语言代码搜索",
  pleaseSelectAnImage: "请选择一张图片",
  pleaseSelectAValidImageType: "请选择有效的图片类型",
  imageTooLargeMaxSizeAllowedIsOneMb: "图片太大,允许的最大尺寸为1MB",
  uploadYourLogoWithPngOrJpegFormat: "请上传您的标志,格式为png或jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "仅允许png和jpeg格式（图片最大尺寸为1MB）",
  delete_theme_content_confirm: "您确定要删除 \"{themecontent}\" 主题内容吗",
  delete_theme_confirm: "您确定要删除 \"{theme}\" 主题吗",
  delete_color_confirm: "您确定要删除 \"{color}\" 颜色吗",
  delete_content_confirm: "您确定要删除 \"{content}\" 内容吗",
  reset_password_confirm: "您确定要为 \"{userid}\" 重置密码吗？",
  block_account_confirm: "您确定要封锁 \"{userid}\" 吗？",
  suspend_account_confirm: "您确定要暂停 \"{userid}\" 吗？",
  active_account_confirm: "您确定要激活 \"{userid}\" 吗？",
  temporaryPasswordFor: "\"{name}\" 的临时密码是",
  needAiToGenerateLogo: "需要AI来生成标志",
  delete_domain_confirm: "您确定要删除域名 \"{domain}\" 吗？",
  previewImageForIllustrationOnly: "显示的预览图片仅供说明参考。",
  actualResultMayVary: "实际结果可能会因网站升级而有所不同。",
  chooseYourPreferedResponsiveLayoutTheme: "选择您喜欢的响应式布局主题",
  chooseYourPreferedColor: "选择您喜欢的颜色",
  please_update_provider_before_edit_game: "请先更新供应商再编辑游戏",
  delete_theme_content_group_confirm: "您确定要删除 \"{themecontentgroup}\" 主题内容组吗？",
  phoneFormat: "例如:+63XXXXXXXXXX",
  change_theme_will_replace_menu: "您确定要更新主题吗？(更改主题将导致菜单被替换)",
  change_provider_seq_confirm: "您确定要更改\"{provider}\"的顺序吗？",
  change_provider_status_confirm: "您确定要更改\"{provider}\"提供商状态吗？",
  actionPerformWillReflectProd: "* 在此执行的任何操作将直接影响到生产环境",
  site_sync_confirm: "您确定要同步到生产环境吗",
  clear_profile_setting_maintenance_confirm: "您确定要清除维护吗",
  change_social_platform_status_confirm: "您确定要更改 \"{name}\" 社交平台的状态吗？",
  search_by_user_id: "按购物车用户ID搜索",
  search_by_site_name: "按网站名称搜索",
  change_social_account_status_confirm: "您确定要更改 \"{name}\" 社交账户状态吗?",
  themeMenuMessage1: "* 通过拖拽菜单项重新排列菜单顺序",
  themeMenuMessage2: "* 如果希望隐藏菜单项,请取消勾选复选框",
  search_by_operator: "按运营商搜索",
  search_by_ticket: "按工单搜索",
  search_member: "搜索会员",
  site_recreate_confirm: "您确定要重新创建网站 \"{name}\" 吗?",
  search_by_game_type: "按游戏类型搜索",
  total_not_count_by_date_range: "此总数不按日期范围计算",
  tooltips_upload_size: "上傳的檔案大小不能超過1mb。",
  tooltips_href: "Href 欄位需要網域的擴充。例如:'yourwebsite.com/promotions',填寫'promotions'即可。",
  d_winlose_chart: "可视化输赢和提款趋势。",
  d_turnover_chart: "分析营业额和存款趋势。",
  d_deposit: "显示存款次数和唯一会员数。",
  d_withdrawal: "显示总提款交易数。",
  d_active_player: "显示玩家的总投注次数和唯一登录数。",
  d_winlose: "显示净输赢总额。",
  d_turnover: "显示总营业额。",
  d_member: "显示所有注册会员的数量。",
  d_referee: "显示用户推荐的总数量。",
  d_verfied_signup: "显示验证用户和新注册用户的数量。",
  d_ftd: "显示首次存款的数量和金额。",
  d_top_winner: "显示玩家ID及总赢额。",
  d_top_loser: "显示玩家ID及总输额。",
  d_top_deposit: "显示玩家ID及从高到低的总存款金额。",
  d_top_withdrawal: "显示玩家ID及从高到低的总提款金额。",
  d_top_promotion: "显示排名、促销ID、名称及玩家领取次数。",
  d_payment_gateway: "显示排名、方法、支付供应商、处理次数、拒绝次数、总次数及成功率。",
  tooltips_promo_member_custom: "請輸入多個會員 ID,並以逗號分隔。例如:member001,member002,member003",
  tooltips_social_facebook: "例如:https://www.facebook.com/",
  tooltips_social_instagram: "例如:https://www.instagram.com/",
  tooltips_social_skype: "例如:skype:<使用者名稱>?chat",
  tooltips_social_telegram: "例如:https://t.me/<ID>",
  tooltips_social_tiktok: "例如: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "例如:<ID>",
  tooltips_social_whatsapp: "例如:https://wa.me/<ID>",
  tooltips_social_youtube: "例如:https://www.youtube.com/<ID>",
  search_by_business_id: "按商户ID搜索",
  ticket_taken_confirm: "您確定要控制此票證 ID \"{name}\"?",
  tooltips_payment_setting: "仅当“玩家充提规则” - “付款设置”设置为“自定义”时,才会反映以下内容",
  tooltips_cms_announcement_main: "最多5个弹窗广告，以获得最佳用户体验",
  tooltips_cms_announcement_title: "为获得最佳用户体验，最多25个字",
  tooltips_cms_announcement_body: "为获得最佳用户体验，最多200个字,每行40个字",
  delete_livechat_confirm: "您确定要删除在线聊天吗？",
  tooltips_vip_name: "为获得最佳用户体验，最多10个字",
  tooltips_sequence: "序列号越小，游戏优先显示顺序越高",
  tooltips_turnover: "玩家流水",
  tooltips_rebate_rate: "玩家回扣巴仙率",
  tooltips_promo_bonus_rate: "建议保持在100%。超出100%的部分需由商户承担风险。",
  tooltips_promo_signup: "建议保持在AUD1-AUD20。超出AUD1-AUD20的部分需由商户承担风险。",
  tooltips_bonus_issue: "建议保持在AUD1-AUD1000。超出AUD1-AUD1000的部分需由商户承担风险。",
  tooltips_vip_cycle_day: "VIP周期以天为单位。",

  vip_info1: "VIP等级一旦创建后，仅可编辑，不能删除。",
  website_launched: "显示已上线的网站总数、截至所选日期的总网站数、总运营商数和今日活跃网站数。",
  new_player_verified_signup: "显示新增玩家数、活跃玩家总数和截至所选日期的玩家总数。",
  depo_withdrawal_diff: "显示总存款和提款金额的差额以及存款和提款详情。",
  bonus: "显示已领取的奖金总额和成功领取的总次数。",
  ggr: "显示所选日期的总毛博彩收入和会员余额总额。",
  turnover: "显示总营业额和截至所选日期的当前RTP百分比。",
  provider_pt_on_global_confirm: "您确定要更改运营商\"\"{name}\"PT条件吗？",

  approve_affiliate_ticket_confirm: "您确定要批准该代理工单吗？",

  choosePackage: "选择配套",
  effortlessCreate: "轻松创建，优化和管理您的网站！",
  raiseNewHeight: "让您的梦想即刻起航！",
  fastSecureStable: "极速、安全、稳定，掌控金流核心",
  realTimeData: "实时数据洞察，一切尽在掌握",
  highLevelTechTeam: "集团级技术团队，全天候护航！",
  strategicEmpowerment: "策略赋能，市场开拓无忧！",
  supportFirst: "无论何时，技术客服等待您的召唤！",
  empowermentBusiness: "配套即战斗力，一步到位，问鼎行业之巅！",
  pleaseFillUpSiteDetails: "请填写您的网站详细信息",
  reviewYourOptionsAndCheckout: "查看选项后进行付款",
  chooseYourPreferedResponsiveLayoutTheme: "请选择您喜好的排版主题",
  chooseYourPreferedColor: "请选择您喜好的色调",
  pleaseSelectTheme: "请选择主题",
  pleaseSelectColor: "请选择色调",
  websiteLayoutAndThemeDesign: "网站布局与设计主题",
  operatorAccCreatedSuccessful: "运营帐户已创建成功",
  delete_default_template_confirm: "您确定要删除 \"{template}\" 迷你游戏模板吗?",
  search_by_template_code: "按模板代码搜索",
  delete_mini_game_confirm: "您确定要删除 \"{minigame}\" 迷你游戏吗?",
  delete_mini_game_template_confirm: "您确定要删除 \"{minigametemplate}\" 迷你游戏模板吗?",
  delete_reward_confirm: "您确定要删除奖励 \"{reward}\" 吗?",
  search_by_game_name: "按游戏名称搜索",
  tooltips_gamereward: "限制: {max}",
  change_gamify_status_confirm: "你确定要更改 \"{gamify}\" 的奖励状态吗？",
  change_gamify_login_status_confirm: "你确定要更改 \"{gamify}\" 的奖励登录状态吗？",
  change_gamify_daily_login_status_confirm: "你确定要更改每日签到（每日登录）奖励状态吗？",
  change_partner_seq_confirm: "您确定要更改\"{id}\"的顺序吗？",
  tooltips_partners_link: "例如:https://www.google.com/",
  delete_partner_confirm: "您确定要删除合作伙伴 \"{name}\" 吗？"
};
